import React, { createContext, ReactNode, useContext } from 'react';

// Context for managing expanded state of all sections
type ExpandedSectionsContextType = {
  expandAll: boolean;
  setExpandAll: (expand: boolean) => void;
};

const ExpandedSectionsContext = createContext<ExpandedSectionsContextType | null>(null);

export const useExpandedSections = () => {
  const context = useContext(ExpandedSectionsContext);
  if (!context) {
    throw new Error('useExpandedSections must be used within ExpandedSectionsProvider');
  }
  return context;
};

type ExpandedSectionsProviderProps = {
  children: ReactNode;
  expandAll: boolean;
  setExpandAll: (expand: boolean) => void;
};

export const ExpandedSectionsProvider: React.FC<ExpandedSectionsProviderProps> = ({
  children,
  expandAll,
  setExpandAll,
}) => {
  return (
    <ExpandedSectionsContext.Provider value={{ expandAll, setExpandAll }}>
      {children}
    </ExpandedSectionsContext.Provider>
  );
};
